import React from "react";
import { Flex } from "@chakra-ui/react";
import { CalendarItem } from "./CalendarItem";
import { CalendarItemState, getDaysInMonth, setDayOfMonth } from "../utils";

type Props = {
	currentMonthYear: Date;
	calculateState: (date: Date) => CalendarItemState;
	onCalendarItemClick: (date: Date) => void;
};

export function CalendarBodyRows(props: Props): JSX.Element {
	// Adjust for calendar header layout: Mo(0) Tu(1) We(2) Th(3) Fr(4) Sa(5) Su(6)
	// JavaScript getDay(): Su(0) Mo(1) Tu(2) We(3) Th(4) Fr(5) Sa(6)
	const firstWeekDayOfMonth = (props.currentMonthYear.getDay() + 6) % 7;
	const numberOfDaysInMonth = getDaysInMonth(props.currentMonthYear);

	const result: JSX.Element[] = [];

	let currentDayOfMonth = 1;
	let weekIndex = 0;
	while (currentDayOfMonth <= numberOfDaysInMonth) {
		const weekDays = [];
		for (let day = 0; day < 7; day++) {
			if ((currentDayOfMonth === 1 && day !== firstWeekDayOfMonth) || currentDayOfMonth > numberOfDaysInMonth) {
				weekDays.push(<CalendarItem key={`empty-${weekIndex}-${day}`} label={""} isSelectable={false} />);
				continue;
			}
			const currentDate = setDayOfMonth(props.currentMonthYear, currentDayOfMonth);
			weekDays.push(
				<CalendarItem
					key={currentDate.toISOString()}
					state={props.calculateState(currentDate)}
					value={currentDate}
					label={currentDate.getDate().toString()}
					onClick={props.onCalendarItemClick}
					isSelectable={true}
				/>
			);
			currentDayOfMonth++;
		}
		result.push(
			<Flex key={`week-${weekIndex}`} flexDir="row">
				{weekDays}
			</Flex>
		);
		weekIndex++;
	}

	return <>{result}</>;
}
